import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles((theme) => ({
  table_container: {
    minHeight: '120px',
    width: '100%',
    padding: '0px',
    position: 'relative',

    '.dnd-scroll-container': {
      overscrollBehavior: 'none',
      scrollSnapType: 'both mandatory',
    },

    '.dnd-scroll-container > *': {
      scrollSnapAlign: 'start',
    },

    // Prevent horizontal scrolling during drag operations
    '&.dragging': {
      overflowX: 'hidden !important',
      '& *': {
        overflowX: 'hidden !important',
      },
      '& table': {
        overflowX: 'hidden !important',
      },
      '& tbody': {
        overflowX: 'hidden !important',
      },
      '& tr': {
        overflowX: 'hidden !important',
      },
      '& td': {
        overflowX: 'hidden !important',
      },
    },
  },

  table_cell_boxes_title: {
    padding: '4px 0',
    fontWeight: 'bold',
    background: theme.palette.grey[700],
  },

  table_cell_general: {
    padding: '4px',
    whiteSpace: 'pre-wrap',
    fontSize: '12px',
    wordBreak: 'break-word',
    overflow: 'hidden',
    alignItems: 'center',
    cursor: 'default',
  },

  general_cell_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },

  table_cell_actions: {
    padding: '2px',
    whiteSpace: 'nowrap',
    fontSize: '12px',
  },

  table_row: {
    maxWidth: '100%',
    height: '70px',
    maxHeight: '70px',
    overflow: 'hidden',
    '&:nth-of-type(odd)': {
      background: '#494949',
    },
    '& *': {
      pointerEvents: 'auto',
    },
    '&.dragging *': {
      pointerEvents: 'none',
    },
    '&:hover': {
      background: '#245353 !important',
      boxShadow: '0px 0px 5px 0px rgba(180, 180, 180, 0.78)',
    },
  },

  table_row_selected: {
    background: '#245353 !important',
    boxShadow: '0px 0px 5px 0px rgba(180, 180, 180, 0.78)',
  },

  table_row_main_selected: {
    height: '50px',
    background: '#3d4b4b !important',
  },

  row_actions_icon: {
    margin: '2px',
    cursor: 'pointer',
    width: '18px',
    height: '18px',
    zIndex: 200,
    '&:hover': {
      background: '#367c7c',
      boxShadow: '0px 0px 5px 0px rgb(180 180 180 / 78%)',
    },
  },

  row_index_icons: {
    margin: '2px',
    cursor: 'pointer',
    zIndex: 200,
    background: theme.palette.accents.dark,
    '&:hover': {
      background: theme.palette.accents.light,
      boxShadow: '0px 0px 5px 0px rgb(180 180 180 / 78%)',
    },
  },

  row_reassign_icon: {
    margin: '0 2px',
    width: '16px',
    height: '16px',
  },

  empty_cell_container: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  empty_actions_container: {
    width: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  table_placeholder: {
    fontSize: '12px',
    color: theme.palette.grey[500],
    padding: '14px 10px 10px',
    borderBottom: 'unset',
  },

  empty_chip_container: {
    fontSize: theme.fonts.responsiveMedium,
    width: '150px',
    borderRadius: '5px',
    padding: '4px 8px',
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '24px',
    background: `${theme.palette.diagnosticsClasses.birads1}70`,
  },

  diagnostic_birads_label: {
    fontSize: theme.fonts.responsiveMedium,
    color: 'white',
    fontWeight: 'bold',
    letterSpacing: '0.05rem',
  },
  tooltip_text: {
    letterSpacing: '0.1rem',
    fontSize: theme.fonts.responsiveMedium,
  },

  class_container: {
    display: 'flex',
    alignItems: 'center',
  },

  size_container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    justifyContent: 'center',
  },

  size_chip: {
    height: '20px',
    width: '90%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    cursor: 'help',
  },

  size_chip_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },

  size_variation_container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },

  icons_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    height: '40px',
    minWidth: '20px',
    maxHeight: '40px',
    overflow: 'hidden',
  },

  action_icons_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '20px',
    width: '100%',
    alignContent: 'center',
    zIndex: 300,
    flexWrap: 'wrap',
    height: '20px',
  },

  location_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    width: '100%',
    flexWrap: 'wrap',
    position: 'relative',
    cursor: 'help',
    height: '100%',
  },

  breast_text: {
    fontSize: '8px',
    position: 'absolute',
    color: theme.palette.grey[500],
  },

  match_icon: {
    color: theme.palette.accents.main,
    animation: '$pulse 1.5s infinite',
  },

  matched_icon: {
    color: theme.palette.accents.main,
    width: '16px',
    height: '16px',
  },

  unmatch_icon: {
    color: 'white',
    width: '16px',
    height: '16px',
  },

  // New styles migrated from OpacitiesTable.js
  index_cell: {
    fontSize: '8px',
  },

  drag_indicator: {
    width: '14px',
    height: '14px',
    color: theme.palette.text.secondary,
  },

  move_icon: {
    width: '18px',
    height: '18px',
  },

  link_icon: {
    width: '20px',
    height: '20px',
  },

  lesion_id_text: {
    fontSize: '10px',
    textTransform: 'uppercase',
  },

  chip_container: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    textTransform: 'uppercase',
    justifyContent: 'center',
  },

  selectNoBorder: {
    '& .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
    },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: 'transparent',
      borderWidth: 0,
    },
    '& .MuiSelect-icon': {
      margin: '0',
      padding: '0',
      width: '18px',
    },
  },

  customChipLabelSmall: {
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    lineHeight: '20px',
    paddingLeft: '0',
    paddingRight: '0',
    justifyContent: 'center',
    width: '100%',
  },

  class_chip: {
    height: '20px',
    fontSize: '12px',
    fontWeight: 'bold',
    color: 'white',
    display: 'flex',
    justifyContent: 'space-between',
    padding: '10px',
    borderRadius: '5px',
    width: '85%',
  },

  chip_texts: {
    fontSize: '12px',
    fontWeight: 'bold',
    lineHeight: '12px',
  },

  class_chip_text: {
    fontSize: '12px',
    lineHeight: '12px',
    '&:hover': {
      fontWeight: 'bold',
    },
  },

  class_dropped_chip_text: {
    fontSize: '10px',
    lineHeight: '10px',
  },

  type_chip: {
    fontSize: '12px',
    height: '22px',
    width: '95%',
    maxWidth: '100%',
    margin: '6px auto',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },

  missing_type_chips: {
    background: 'rgba(53, 109, 124, 0.83)',
    whiteSpace: 'wrap',
    maxWidth: '100%',
  },

  diagnostics_type_chips: {
    background: 'rgba(67, 93, 100, 0.78)',
  },

  diagnostics_new_type_chips: {
    background: 'rgba(55, 87, 105, 0.78)',
  },

  microcalc_type_chips: {
    background: 'rgba(90, 141, 137, 0.78)',
  },

  severity_change_icon: {
    width: '11px',
    height: '12px',
    lineHeight: '12px',
  },

  history_size_container: {
    display: 'flex',
    alignItems: 'center',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    justifyContent: 'center',
    maxWidth: '100%',
    width: '100%',
    margin: '0 2px',
  },

  history_date_label: {
    fontSize: '10px',
    color: theme.palette.text.secondary,
    marginBottom: '2px',
    display: 'flex',
    alignItems: 'center',
    gap: '4px',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
    maxWidth: '100%',
    justifyContent: 'center',
  },

  severity_stable: {
    fontSize: '14px',
    transform: 'rotate(90deg)',
    lineHeight: '14px',
  },

  severity_up: {
    fontSize: '16px',
  },

  severity_down: {
    fontSize: '16px',
  },

  size_change_icon: {
    color: 'inherit',
    cursor: 'help',
    width: '13px',
    height: '13px',
  },

  size_change_chip: {
    height: '14px',
    fontSize: '12px',
    fontWeight: 'bold',
    color: 'white',
  },

  size_change_date: {
    fontSize: '9px',
    lineHeight: '10px',
    marginTop: '2px',
    height: '11px',
    color: theme.palette.text.secondary,
  },

  index_cell_container: {
    width: '20px',
    height: '20px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  history_timeline_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    position: 'relative',
    width: '100%',
    overflowX: 'scroll',
    overflowY: 'hidden',
    maxHeight: '65px',
    zIndex: 20,
    '&::-webkit-scrollbar': {
      height: '4px',
    },
    '&::-webkit-scrollbar-track': {
      background: 'transparent',
    },
    '&::-webkit-scrollbar-thumb': {
      background: theme.palette.grey[400],
      borderRadius: '2px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      background: theme.palette.grey[600],
    },
    // Prevent horizontal scrolling during drag operations
    '.dragging &': {
      overflowX: 'hidden !important',
    },
  },

  history_timeline_line: {
    position: 'absolute',
    top: '50%',
    left: '45px',
    right: '45px',
    height: '2px',
    backgroundColor: theme.palette.grey[700],
    transform: 'translateY(-50%)',
    zIndex: 1,
  },

  history_item_container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    zIndex: 200,
    cursor: 'pointer',
    transform: 'scale(1)',
    transition: 'transform 0.2s ease',
    width: '95px',
    minWidth: 'content-fit',
    minHeight: '55px',
    justifyContent: 'center',
    alignContent: 'center',
  },

  history_chip: {
    fontSize: '10px',
    height: '20px',
    minWidth: '50px',
    backgroundColor: theme.palette.background.paper,
    cursor: 'pointer',
    '&:hover': {
      boxShadow: '1px 2px 2px 1px rgb(57 57 57 / 78%), 0px 0px 5px 0px rgb(255 255 255 / 78%)',
      fontWeight: 'bold',
    },
  },

  history_size_text: {
    fontSize: '9px',
    color: theme.palette.text.secondary,
    marginTop: '2px',
    textAlign: 'center',
  },

  menu_button: {
    color: 'white',
    width: '16px',
    height: '16px',
  },

  dropdown_menu: {
    position: 'absolute',
    top: '100%',
    right: 0,
    zIndex: 9999,
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '4px',
    boxShadow: theme.shadows[8],
    minWidth: '150px',
    padding: '4px 0',
    maxHeight: '200px',
    overflow: 'auto',
  },

  dropdown_menu_item: {
    display: 'flex',
    alignItems: 'center',
    padding: '8px',
    cursor: 'pointer',
    fontSize: '12px',
    color: theme.palette.text.primary,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
    },
  },

  dropdown_icon: {
    width: '16px',
    height: '16px',
    marginRight: '8px',
  },

  dropdown_unmatch_icon: {
    width: '18px',
    height: '18px',
    marginRight: '8px',
  },

  breast_text_left: {
    left: '2px',
  },

  breast_text_right: {
    right: '2px',
  },

  '@keyframes pulse': {
    '0%': {
      transform: 'scale(1)',
      opacity: 0.7,
    },
    '50%': {
      transform: 'scale(1.1)',
      opacity: 1,
    },
    '100%': {
      transform: 'scale(1)',
      opacity: 0.7,
    },
  },

  // Section per breast styles
  section_per_breast: {
    marginBottom: '32px',
    borderRadius: '5px',
    padding: '2px',
  },

  section_header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },

  section_title: {
    padding: '8px 1px',
    fontWeight: 'bold',
    color: '#fff',
    fontSize: '14px',
    textTransform: 'uppercase',
    backgroundColor: '#414141',
  },

  highest_class_badge: {
    cursor: 'help',
    fontWeight: 'bold',
    padding: '4px',
    borderRadius: '5px',
    width: '100px',
    fontSize: theme.fonts.responsiveMedium,
    textAlign: 'center',
    marginLeft: '10px',
    marginRight: '4px',
    height: '20px',
    '&:hover': {
      boxShadow: '1px 1px 1px 1px rgb(75 75 75), 0px 0px 3px 1px rgb(147 147 147 / 85%)',
      transform: 'scale(1.1)',
      transition: 'transform 0.2s ease',
      marginRight: '10px',
    },
  },

  table: {
    tableLayout: 'fixed',
    width: '100%',
  },

  table_body: {
    backgroundColor: '#4f4f4f',
  },

  // Loading overlay styles
  loading_overlay: {
    height: '100%',
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'absolute',
    zIndex: 1000,
    top: 0,
    left: 0,
    backgroundColor: 'rgba(51, 51, 51, 0.6)',
  },

  loading_animation: {
    width: '100px',
    height: '100px',
    borderRadius: '50%',
    opacity: 0.5,
  },

  highest_class_badge_container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },

  highest_class_container: {
    display: 'inline-block',
  },

  // Filter controls styles
  filter_controls_container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
    alignItems: 'flex-start',
    marginBottom: '16px',
    justifyContent: 'flex-start',
    height: '50px',
    minHeight: 'fit-content',
  },

  filter_form_control: {
    width: '150px',
    display: 'flex',
    justifyContent: 'center',
  },

  filter_input_label: {
    color: '#fff',
    fontSize: theme.fonts.responsiveMedium,
  },

  filter_select: {
    color: '#fff',
    fontSize: theme.fonts.responsiveMedium,
    height: '36px',
    '&.MuiSelect-outlined': {
      padding: '8px',
    },
  },

  filter_menu_paper: {
    maxHeight: 160,
    fontSize: theme.fonts.responsiveMediumBig,
  },

  filter_menu_item: {
    fontSize: theme.fonts.responsiveMediumBig,
    padding: '4px 8px',
  },

  filter_reset_button: {
    fontSize: theme.fonts.responsiveMedium,
    color: '#fff',
    height: '18px',
    margin: '4px',
    minHeight: '18px',
    backgroundColor: '#425f5f',
    '&:hover': {
      backgroundColor: '#367c7c',
    },
  },

  missed_button: {
    fontSize: theme.fonts.responsiveMedium,
    color: '#fff',
    height: '18px',
    margin: '4px',
    minHeight: '18px',
    '&:hover': {
      backgroundColor: '#367c7c',
    },
  },

  filter_controls_icon: {
    width: '16px',
    height: '16px',
  },
}));
